import { Box } from "@mui/material";
import LoadingGif from "./../../assets/images/loading.gif";
import { useEffect, useState } from "react";
interface PropsType {
    loading: boolean | undefined | null
}

const PageLoading = ({ loading }: PropsType) => {
    const [show, setShow] = useState<boolean>(false);

    useEffect(() => {
        if(loading === false)
        {
            setTimeout(() => {
                if(loading === false)
                {
                    setShow(false);
                }
            }, 1500);
        }
        else
        {
            setShow(true);
        }
    }, [loading]);

    return (
        <Box position={'fixed'} left={0} top={0} zIndex={1000} width={`100%`} height={`100%`} display={show ? `block` : `none`} id="loading_gif">
            <Box display={`flex`} justifyContent={`center`} alignContent={`center`} alignItems={`center`} width={`100%`} height={`100%`} bgcolor={'white'} sx={{
                opacity: loading ? '100%' : '0%',
                transition: 'all 1500ms'
            }}>
                <img src={LoadingGif} alt="Loading_Gif" style={{
                    width: '100%',
                    maxWidth: '500px'
                }} />
            </Box>
        </Box>
    )
}

export default PageLoading;